import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { Pagination } from '../../ofbiz-form-model';

@Injectable({
  providedIn: 'root'
})

export class PaginationService {
  pagination:BehaviorSubject<Pagination> = new BehaviorSubject<Pagination>(null);
  paginate$ = this.pagination.subscribe((pagination:Pagination) => {return pagination?.paginate || false});

  viewSizeOptions = [
    {value:10,key:"10 per page"},
    {value:20,key:"20 per page"},
    {value:30,key:"30 per page"},
    {value:40,key:"40 per page"},
    {value:50,key:"50 per page"}
  ];
  viewSize$ = new Subject<number>();
  _previous = new Subject

  constructor() { }
  /**
   * 
   * @param listSize The complete resultSet size returned from the backend
   * @param viewIndex View Index returened from the backend - (page number)
   * @param viewSize Number of records to be returned from the backend
   * @param currentListSize Number of items in the current page. Will be equal to the viewSize when the listSize is bigger than the viewSize
   */
  setPagination(listSize:number,viewIndex:number,viewSize:number,currentListSize:number):void{
    this.getPagination().pipe(take(1)).subscribe(pagination => {
      if(pagination == null){
        let pagination:Pagination = {paginate:false};
        if(listSize > viewSize && viewSize == currentListSize){
          pagination.paginate = true;
          pagination.event = "start";
          pagination.listSize = listSize;
          pagination.numberOfpages = Math.ceil(listSize/viewSize);
          pagination.currentPage = viewIndex+1;
          pagination.viewIndex = viewIndex;
          pagination.viewSize = viewSize;
          if(viewIndex > 0){
            pagination.highIndex = viewSize*(viewIndex+1);
            pagination.lowIndex = (pagination.highIndex-viewSize)+1;
          }else{
            pagination.highIndex = viewSize;
            pagination.lowIndex = 1;
          }
          pagination.nextViewIndex = viewIndex+1;
          pagination.previousViewIndex = viewIndex-1;
        }else if(listSize > viewSize && currentListSize < viewSize){
          pagination.lowIndex = listSize - (currentListSize-1)//viewSize*viewIndex-(viewSize -1);
          pagination.highIndex = listSize //this.pagination.lowIndex+currentListSize-1;
          pagination.nextViewIndex = viewIndex+1;
          pagination.previousViewIndex = viewIndex-1;
        }
        pagination.selectedViewSize = this.viewSizeOptions.find(viewSizeOption => viewSizeOption.value == viewSize);
        console.log({Pagination:pagination});
        this.pagination.next(pagination)
       }
    });

    
  }

  resetPaginagtion(){
    this.pagination.next(null);
  }

  getPagination():Observable<Pagination>{
    return this.pagination.asObservable()
  }

  onViewSize(viewSize:number){
    this.pagination.subscribe((pagination:Pagination) => {
      let currentViewSize = pagination.viewSize;
      if(currentViewSize != viewSize){
        pagination.viewSize = viewSize;
        pagination.event = "setViewSize"
        this.pagination.next(pagination)
      }
    })
  }

  onFirst(){
    this.pagination.pipe(take(1)).subscribe((pagination:Pagination) => {
      pagination.event = "first";
      pagination.viewIndex = 0;
      this.pagination.next(pagination)
    })
  }

  onPrevious(){
    this.pagination.pipe(take(1)).subscribe((pagination:Pagination) => {
      if(pagination.previousViewIndex != undefined && pagination.previousViewIndex != null && pagination.previousViewIndex > 0){
        pagination.viewIndex = pagination.previousViewIndex;
        pagination.previousViewIndex = pagination.previousViewIndex - 1;
      }else{
        pagination.viewIndex = 0;
        pagination.previousViewIndex = -1;
      }
      pagination.nextViewIndex = pagination.viewIndex + 1;
      pagination.currentPage = pagination.currentPage - 1;
      pagination.event = "previous"; 
      this.pagination.next(pagination)
    })
  }

  onNext(){
    this.pagination.pipe(take(1)).subscribe((pagination:Pagination) => {
      pagination.viewIndex = pagination.nextViewIndex;
      pagination.nextViewIndex = pagination.viewIndex + 1;
      pagination.previousViewIndex = pagination.viewIndex - 1;
      pagination.currentPage = pagination.viewIndex+1;
      pagination.lowIndex = (pagination.viewIndex * pagination.viewSize)+1;
      pagination.highIndex = this.setHighIndex(pagination.listSize,pagination.viewIndex,pagination.viewSize);
      pagination.event = "next";
      this.pagination.next(pagination)
    })
  }

  onLast(){
    this.pagination.pipe(take(1)).subscribe((pagination:Pagination) => {
      pagination.viewIndex = pagination.numberOfpages-1;
      pagination.previousViewIndex = pagination.viewIndex - 1;
      pagination.event = "last";
      this.pagination.next(pagination)
    })

   }

   setHighIndex(listSize:number,viewIndex:number,viewSize:number):number{
    let highIndex = viewIndex * viewSize;
    if(highIndex > listSize){
      highIndex = listSize
    }
    return
   }
}
